import Vue from 'vue'
import App from './App.vue'
import ajax from './assets/js/axios.config';
import VueLazyload from "vue-lazyload";
import utils from './assets/js/utils'
import toast from './components/Toast';
Vue.use(VueLazyload);

import "./assets/scss/main.scss";

Vue.config.productionTip = false

Vue.prototype.$ajax = ajax
Vue.prototype.$utils = utils

Vue.use(toast);

new Vue({
  render: h => h(App),
}).$mount('#app')
